import { FeatureMap } from "@xemplo/feature-flag";

export const Features = {
  XemploPay: "XemploPay",
} as const;

export type Features = (typeof Features)[keyof typeof Features];

export const featureMap: FeatureMap = {
  [Features.XemploPay]: {
    name: "Xemplo Pay",
    enabled: {
      environment: ["dev"],
    },
  },
};
